import { graphql } from "@apollo/client/react/hoc";
import flowRight from "lodash/flowRight";

import { withInstrumentationContext } from "components/instrumentation/source";
import { withGalleryModalContext } from "components/pages/property/listing/components/GalleryModal/context";
import { WWW_BUILDING_LISTING_QUERY } from "components/pages/property/listing/graphql";
import {
  withAppContext,
  withBootstrapContext,
  withCookiesContext,
  withPropertyListingContext,
  withResponsiveContext,
  withSearchContext,
} from "components/store/source";

import { withChargebudContext } from "services/chargebud/chargebudContext";

import App from "./App";

export default flowRight([
  withBootstrapContext,
  withCookiesContext,
  withInstrumentationContext,
  withAppContext,
  // TODO: The server can fetch listing data and bake it into the page,
  // TODO: just like the current listing page on dotcom
  // TODO: Need to revisit when backend is ready.
  graphql(WWW_BUILDING_LISTING_QUERY, {
    // skip if listing is passed in from server
    skip: ({ listing }) => !!listing,
    options: ({ urlParams: { id } }) => ({
      variables: { id },
    }),
    props: ({ data: { buildingListing, loading } }) => {
      return {
        listing: buildingListing,
        isListingLoading: loading,
      };
    },
  }),
  withSearchContext,
  withPropertyListingContext,
  withGalleryModalContext,
  withResponsiveContext,
  withChargebudContext,
])(App);
